import HOME from "../constants/home-constant"

const initState = {
  qrCode: false,
  export: true,
  saveBtn: false,
  exportBtn: true,
  refresTable: false,
  printAllBtn: true,
  deleteBtn: true,
  editBtn: true,
  modalShow: false,
  previewData: true,
  tableData: [],
  currentData: [],
  date: false,
  parameter: false,
  description: false,
  createdBy: false,
  exportTo: '',
  isEdit: false,
  isSaveClick: true,
  showID: false,
}

export const HomeReducer = (state = initState, action) => {
  switch(action.type) {
    case HOME.SET_PROP:
      return {
        ...state,
        [action.prop]: action.value
      };
    case HOME.RESET_PROP:
      return {
        ...initState
      };

    default:
      return state;
  }
}